import { ButtonV2, Spinner } from '@travelwin/core';
import { ButtonV2Props } from '@travelwin/core/src/components/Button/ButtonV2';
import cn from 'classnames';
import {
  ForwardedRef,
  forwardRef,
  PropsWithChildren,
  SyntheticEvent,
} from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  stockAvailable: boolean | null;
  handleBuyNowClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  size?: ButtonV2Props['size'];
  className?: string;
  radius?: ButtonV2Props['radius'];
} & PropsWithChildren;

const BuyButton = (
  {
    stockAvailable,
    handleBuyNowClick,
    isLoading,
    size = 'medium',
    className,
    children,
    radius,
  }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const cssClassName = 'c-PlanCard';
  const { t } = useTranslation();

  return (
    <div
      ref={ref}
      className={cn(`${cssClassName}__buy-btn-container`, className)}
    >
      {stockAvailable === false ? (
        <span className={`${cssClassName}__buy-btn-out-of-stock`}>
          {t('plan_card.out_of_stock', 'Out of stock')}
        </span>
      ) : (
        <ButtonV2
          variant="primary"
          size={size}
          data-testid="button-buy-now"
          radius={radius}
          onClick={handleBuyNowClick}
        >
          {isLoading ? <Spinner size={16} color="white" /> : children}
        </ButtonV2>
      )}
    </div>
  );
};

export default forwardRef<HTMLDivElement, Props>(BuyButton);
